import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/index.js"


// --- VUETIFY 3 SETUP ---

// 1. Import the necessary CSS styles
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css' // Optional, but recommended for icons

// 2. Import the Vue 3 specific creation function and required components
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// 3. Create the vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
})

// --- APP INITIALIZATION ---

// 4. Create your main app instance
const app = createApp(App)

app.use(router)


// 5. Tell the app instance to use the configured vuetify plugin
app.use(vuetify)


// 6. Mount the app to the DOM element specified in index.html
app.mount('#app')
